var map = {
	"./account.svg": 9250,
	"./advanced.svg": 54887,
	"./alarm.svg": 83840,
	"./arrow-left.svg": 95426,
	"./badge-basic.svg": 40127,
	"./badge-community.svg": 58402,
	"./badge-membership.svg": 86619,
	"./badge-participation.svg": 94026,
	"./badge-role.svg": 21979,
	"./badge-ticket.svg": 41287,
	"./badges-new.svg": 6148,
	"./badges.svg": 55537,
	"./ban.svg": 3208,
	"./bell-notification.svg": 52442,
	"./bell-ring.svg": 22897,
	"./bitcoin.svg": 77461,
	"./calendar-check.svg": 72940,
	"./calendar-days.svg": 38117,
	"./calendar-duration.svg": 87980,
	"./calendar-event.svg": 61788,
	"./calendar.svg": 97915,
	"./chat-dots.svg": 84828,
	"./check.svg": 66015,
	"./checkbox-fill.svg": 75744,
	"./checklist.svg": 42235,
	"./chevron-down.svg": 70323,
	"./chevron-left.svg": 21156,
	"./chevron-right.svg": 52971,
	"./chevron-up.svg": 30540,
	"./circle-check.svg": 61134,
	"./clock-check.svg": 53194,
	"./clock.svg": 31893,
	"./cloud-off.svg": 27292,
	"./cog.svg": 57866,
	"./color.svg": 1854,
	"./compass.svg": 90851,
	"./copy.svg": 84198,
	"./credit-card.svg": 23693,
	"./cross.svg": 26219,
	"./crypto.svg": 3966,
	"./cube.svg": 19634,
	"./cup.svg": 99431,
	"./dashboard.svg": 6551,
	"./delete-solid.svg": 44222,
	"./download.svg": 73733,
	"./edit-pencil.svg": 1025,
	"./edit-solid.svg": 85043,
	"./edit.svg": 37165,
	"./emoji_activities.svg": 3891,
	"./emoji_animals_nature.svg": 14751,
	"./emoji_flags.svg": 4201,
	"./emoji_food_drink.svg": 34839,
	"./emoji_objects.svg": 31572,
	"./emoji_smileys_people.svg": 16886,
	"./emoji_symbols.svg": 16519,
	"./emoji_travel_places.svg": 59723,
	"./eye.svg": 60764,
	"./file-solid.svg": 48085,
	"./file-upload.svg": 43099,
	"./flag.svg": 19815,
	"./globe.svg": 16248,
	"./help.svg": 44320,
	"./image.svg": 26296,
	"./infinity.svg": 6177,
	"./info.svg": 64069,
	"./key.svg": 14006,
	"./layer.svg": 19308,
	"./layers.svg": 35079,
	"./link-break.svg": 35599,
	"./link.svg": 95765,
	"./location.svg": 9716,
	"./lock.svg": 70732,
	"./log-out.svg": 40698,
	"./magic.svg": 82290,
	"./magnifying-glass.svg": 28417,
	"./mail.svg": 27884,
	"./map-pin.svg": 70875,
	"./map.svg": 78417,
	"./medal.svg": 75426,
	"./more-vertical.svg": 59957,
	"./newspaper.svg": 78078,
	"./note-edit.svg": 61218,
	"./notebook.svg": 34522,
	"./ongoing.svg": 55452,
	"./paper-plane.svg": 58360,
	"./play.svg": 19443,
	"./plus.svg": 29989,
	"./qr-code.svg": 99686,
	"./qrcode.svg": 26531,
	"./quest.svg": 19809,
	"./question-circle.svg": 58930,
	"./radio-fill.svg": 51484,
	"./refresh.svg": 31394,
	"./rotate.svg": 18704,
	"./save.svg": 62746,
	"./scan.svg": 70174,
	"./select-multiple.svg": 92994,
	"./send-solid.svg": 61773,
	"./settings.svg": 77514,
	"./shape_1.svg": 64616,
	"./shape_2.svg": 99003,
	"./shape_3.svg": 38634,
	"./shape_4.svg": 61845,
	"./shape_5.svg": 89236,
	"./shape_6.svg": 37447,
	"./show.svg": 21842,
	"./smile.svg": 86863,
	"./smiley.svg": 32644,
	"./star.svg": 2413,
	"./stop.svg": 69833,
	"./sub-communities.svg": 32265,
	"./switch-community.svg": 41981,
	"./text-align-left.svg": 18954,
	"./trash-empty.svg": 19385,
	"./trash.svg": 46509,
	"./triangle-left.svg": 45841,
	"./triangle-right.svg": 86524,
	"./trophy.svg": 83879,
	"./unfold-more.svg": 4577,
	"./user-add.svg": 71742,
	"./user-square.svg": 37344,
	"./user.svg": 3808,
	"./users.svg": 12515,
	"./warning.svg": 68735,
	"./wavy-check.svg": 10377
};



function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then((id) => (__webpack_require__(id)));
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | icon-[request] */ 880).then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 77439;
module.exports = webpackAsyncContext;